import type { CaptureFeedback, Landmark } from '../types';
import { IDX } from '../constants';

/** Key landmarks used to decide whether a new pose frame should trigger React state. */
const STABILITY_PROBE_INDICES = [
  IDX.L_SHO,
  IDX.R_SHO,
  IDX.L_HIP,
  IDX.R_HIP,
  IDX.L_KNEE,
  IDX.R_KNEE,
];

export function landmarksMeaningfullyChanged(
  prev: Landmark[] | null,
  next: Landmark[] | null,
  epsilonPx = 3,
): boolean {
  if (prev === next) return false;
  if (!prev || !next) return true;
  if (prev.length !== next.length) return true;
  for (const i of STABILITY_PROBE_INDICES) {
    const a = prev[i];
    const b = next[i];
    if (!a || !b) return true;
    if (Math.abs(a.x - b.x) > epsilonPx || Math.abs(a.y - b.y) > epsilonPx) return true;
  }
  return false;
}

export function captureFeedbackEquals(
  a: CaptureFeedback | null,
  b: CaptureFeedback | null,
): boolean {
  if (a === b) return true;
  if (!a || !b) return !a && !b;
  return a.message === b.message && a.type === b.type;
}

export function deriveRealtimeCaptureFeedback(
  landmarks: Landmark[] | null,
  visibilityThreshold: number,
): CaptureFeedback | null {
  if (!landmarks?.length) {
    return { message: 'No person detected', type: 'info' };
  }
  const visiblePoints = landmarks.filter((p) => (p.visibility || 0) > visibilityThreshold).length;
  if (visiblePoints < 15) {
    return { message: 'Make sure full body is visible', type: 'warning' };
  }
  return null;
}
